<template>
  <div ref="container">
    <h2>{{ $t('sitesection.title') }}</h2>
    <p>{{ $t('sitesection.subtitle') }}</p>

    <div class="grid m-0">
      <SiteSelectionPanelComponent
        class="col-12 lg:col-4"
        :sites="sites"
        @site-selection="onSiteSelection"
        @cluster-selection="onClusterSelection"
      />

      <SiteSelectionMapComponent
        ref="mapComponent"
        class="col-12 lg:col-8"
        :sites="sites"
        @site-selection="onSiteSelection"
      />
    </div>
  </div>
</template>

<script>
import SiteSelectionPanelComponent from "@/components/map/SiteSelectionPanelComponent.vue";
import SiteSelectionMapComponent from "@/components/map/SiteSelectionMapComponent.vue";

export default {
  name: 'SiteSelectionComponent',
  components: {SiteSelectionMapComponent, SiteSelectionPanelComponent},
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    sites: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    selectedSite: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
        this.$emit('change', value)
      }
    }
  },
  methods: {
    onSiteSelection(site) {
      this.selectedSite = site;
      this.$refs.mapComponent.zoomOnSite(site.id);
      this.scrollToAppointment();
    },
    onClusterSelection(cluster) {
      this.$refs.mapComponent.zoomOnCluster(cluster.name);
    },
    scrollToAppointment() {
      let element = this.$refs.container;
      window.scrollTo({left: 0, top: element.offsetTop, behavior: "smooth"});
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
